/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One organization's platform OpenRouter key of a given type, without its key material.
 */
export type AdminOpenRouterKey = {
  /**
   * When the key row was created.
   */
  createdAt: Date;
  /**
   * Administrative view of every reason currently disabling the key. Values are open-ended for forward compatibility.
   */
  disableCauses?: Array<string> | undefined;
  /**
   * Whether the key is locked down (refused locally and disabled upstream).
   */
  disabled: boolean;
  /**
   * The organization's Speakeasy account type (e.g. free, pro, enterprise).
   */
  gramAccountType: string;
  /**
   * Which upstream key this row provisions: 'chat' pays for customer-facing completions, 'internal' pays for platform-initiated LLM usage.
   */
  keyType: string;
  /**
   * Monthly credit ceiling last mirrored from OpenRouter.
   */
  monthlyCredits: number;
  /**
   * Organization that owns the key.
   */
  organizationId: string;
  /**
   * Display name of the owning organization.
   */
  organizationName: string;
  /**
   * Slug of the owning organization.
   */
  organizationSlug: string;
  /**
   * When the key row was last updated.
   */
  updatedAt: Date;
};

/** @internal */
export const AdminOpenRouterKey$inboundSchema: z.ZodMiniType<
  AdminOpenRouterKey,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    disable_causes: z.optional(z.array(z.string())),
    disabled: z.boolean(),
    gram_account_type: z.string(),
    key_type: z.string(),
    monthly_credits: z.int(),
    organization_id: z.string(),
    organization_name: z.string(),
    organization_slug: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "disable_causes": "disableCauses",
      "gram_account_type": "gramAccountType",
      "key_type": "keyType",
      "monthly_credits": "monthlyCredits",
      "organization_id": "organizationId",
      "organization_name": "organizationName",
      "organization_slug": "organizationSlug",
      "updated_at": "updatedAt",
    });
  }),
);

export function adminOpenRouterKeyFromJSON(
  jsonString: string,
): SafeParseResult<AdminOpenRouterKey, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AdminOpenRouterKey$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AdminOpenRouterKey' from JSON`,
  );
}
